var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco05Gl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "32px",
    viewBox: "0 0 27 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1/4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1280,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculadoraV3-galones1",
    transform: "translate(-954.000000, -449.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1/4-copy",
    transform: "translate(944.000000, 439.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1/4",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    stroke: "#2268D1",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 1.81818182,
    y: 1.81818182,
    width: 23.3636364,
    height: 28.2727273
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    stroke: "#2268D1",
    strokeWidth: 2,
    fill: "#F6F6F6",
    x: 1,
    y: 1,
    width: 25,
    height: 2.90909091,
    rx: 1.45454545
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.090909, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.999,0 L18,11.0185144 C18,12.7582114 16.589697,14.1685144 14.85,14.1685144 C14.697268,14.1685144 14.5470748,14.1576445 14.4001518,14.1366361 L14.4001518,14.1366361 L14.4,18.2045455 C14.4,19.4471861 13.3926407,20.4545455 12.15,20.4545455 C10.9073593,20.4545455 9.9,19.4471861 9.9,18.2045455 L9.9,18.2045455 L9.90104921,9.96900441 C9.15858975,10.887298 8.02286919,11.4745011 6.75,11.4745011 C4.65121601,11.4745011 2.92530369,9.8780477 2.72060193,7.83319229 C2.56883169,7.86548909 2.41140046,7.88248337 2.25,7.88248337 C1.00735931,7.88248337 -2.05346851e-12,6.87512406 -2.05346851e-12,5.63248337 L-2.05346851e-12,5.63248337 L0,0 L17.999,0 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8177273,1.63636364 L18.8181818,11.3283259 C18.8181818,12.8307915 17.6001928,14.0487805 16.0977273,14.0487805 C15.965566,14.0487805 15.8356058,14.0393563 15.7084821,14.0211433 L15.7084821,14.0211433 L15.7090909,17.6931818 C15.7090909,18.7663715 14.8390988,19.6363636 13.7659091,19.6363636 C12.6927194,19.6363636 11.8227273,18.7663715 11.8227273,17.6931818 L11.8227273,17.6931818 L11.8226506,10.3551153 C11.1814164,11.14749 10.2010073,11.654102 9.10227273,11.654102 C7.25877134,11.654102 5.748374,10.227914 5.6158715,8.41999229 C5.48679372,8.44699892 5.35300951,8.46119734 5.21590909,8.46119734 C4.14271941,8.46119734 3.27272727,7.59120521 3.27272727,6.51801552 L3.27272727,6.51801552 L3.27272727,1.63636364 L18.8177273,1.63636364 Z",
    id: "Combined-Shape",
    fill: "#B7DAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9990908,1 L17,11.0185144 C17,11.6122205 16.7593531,12.1497205 16.3702796,12.538794 C15.7961493,13.1129243 14.8988207,13.3638561 13.9746155,12.9952679 L13.9746155,12.9952679 L13.3991143,18.1569139 C13.4126358,18.5209152 13.27045,18.8518624 13.0338835,19.0884289 C12.807678,19.3146344 12.495178,19.4545455 12.15,19.4545455 C11.8204117,19.4545455 11.5205795,19.327034 11.2972746,19.1185369 C11.0792065,18.9149293 10.9336785,18.6342712 10.9051717,18.3196917 L10.9051717,18.3196917 L10.8996544,7.14338719 L9.12342303,9.34027751 C8.56419013,10.0319517 7.7088275,10.4745011 6.75,10.4745011 C5.96371603,10.4745011 5.24687041,10.177039 4.70607365,9.68832875 C4.16017187,9.1950052 3.79306161,8.50709569 3.7156287,7.7335844 C3.6731786,7.30953177 3.72116107,6.89343806 3.84514062,6.50655114 C3.55865234,6.71023356 3.16508792,6.81956565 2.69094775,6.83363207 C2.1657779,6.8492124 1.73235868,6.74226282 1.42671121,6.51189016 C1.17668162,6.32343781 1.03300786,6.05160061 1.005156,5.74727667 L1.005156,5.74727667 L1.00089745,1 L16.9990908,1 Z",
    id: "Combined-Shape",
    stroke: "#2268D1",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    stroke: "#2268D1",
    strokeWidth: 2,
    fill: "#F6F6F6",
    x: 1,
    y: 28,
    width: 25,
    height: 2.90909091,
    rx: 1.45454545
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco05Gl);
export default __webpack_public_path__ + "static/media/ico-0.5-gl.c27e6406.svg";
export { ForwardRef as ReactComponent };